import { Button, Form, Row, Col, Input, message, Drawer, Space } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleCreateAllowance } from "../../../api/allowances";
import { AiOutlineClose } from "react-icons/ai";

export default function CreateAllowance({ isVisible, setVisible }: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate } = useMutation({
    mutationFn: handleCreateAllowance,
    onSuccess: () => {
      message.success("Created Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["allowances"] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const { fuel_rate, fuel_amount, ...rest } = await form.getFieldsValue();
    const data = {
      fuel: {
        rate: fuel_rate,
        amount: fuel_amount,
        price: fuel_rate * fuel_amount,
      },
      ...rest,
    };
    await mutate(data);
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  return (
    <Drawer
      title={`CREATE LOCATION`}
      placement={"right"}
      width={window.innerWidth > 1200 ? "48%" : "auto"}
      onClose={() => setVisible(!isVisible)}
      open={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <Form
        id="createAllowance"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-row, justify-between"></div>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="location"
              label="Location"
              rules={[
                {
                  required: true,
                  message: "Please enter location",
                },
              ]}
            >
              <Input type="" placeholder="Location" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="distance"
              label="Distance  ( KM )"
              rules={[
                {
                  required: true,
                  message: "Please enter distance",
                },
              ]}
            >
              <Input type="" placeholder="Distance" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="driver"
              label="Driver's Amount"
              rules={[
                {
                  required: true,
                  message: "Please enter driver's amount",
                },
              ]}
            >
              <Input type="" placeholder="Driver Amount" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="fuel_amount"
              label="Total Fuel Amount ( Litres )"
              rules={[
                {
                  required: true,
                  message: "Please enter fuel amount",
                },
              ]}
            >
              <Input type="" placeholder="Total Fuel Amount" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="fuel_rate"
              label="Fuel Rate ( Per Litre )"
              rules={[
                {
                  required: true,
                  message: "Please enter distance",
                },
              ]}
            >
              <Input type="" placeholder="Distance" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button danger type="primary" htmlType="submit">
            Create
          </Button>
          <Button danger htmlType="button" className="mx-2" onClick={clearForm}>
            Reset
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}
